import axios from "axios";

import { LMS_BASE_URL } from "../../../utils/http/http-common";
import { LMS_TOKEN } from "../../../utils/cookiesmanager";

export const getCertificateAPICall = async (languageid = 1) => {
  const token = localStorage.getItem(LMS_TOKEN);

  try {
    const response = await axios.get(
      `${LMS_BASE_URL}/course/certificate-list?languageId=${languageid}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error.config.data;
  }
};

export const getCertificatePreview = async (params) => {
  try {
    const { courseId, moduleId } = params || {};
    
    const token = localStorage.getItem(LMS_TOKEN);

    const response = await axios.get(
      `${LMS_BASE_URL}/certificate/preview?courseId=${courseId}&moduleId=${moduleId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      },
    );

    return response;
  } catch (error) {
    throw error.config.data;
  }
};

export const certificateDownloadAPICall = async (params) => {
  const { courseId, moduleId } = params || {};

  const token = localStorage.getItem(LMS_TOKEN);

  try {
    const response = await axios.get(
      `${LMS_BASE_URL}/certificate/download?courseId=${courseId}&moduleId=${moduleId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob", // ⭐ IMPORTANT
      }
    );

    return response;
  } catch (error) {
    throw error;
  }
};